import trackEvent from './trackEvent'

export default function logPageView(selectSource, membership_referral) {
  const source = {
    notify: '每日回顾',
    lucky: '随机漫步',
    wechat: '微信输入',
    account: '账号详情',
    hotkey: '快捷键设置',
    notion_sync: 'Notion同步',
    export: '导出数据',
    membership: '会员中心',
    stat: '记录统计',
    notifications: '消息通知',
    referral: '奖励计划',
    incoming_webhook: '记录API',
  }

  trackEvent('页面访问', source[selectSource] || '首页', membership_referral)
}
